import { AxiosPublic } from "../config/axios";

export async function getArtists(query) {
  return await AxiosPublic.get("artist", { params: { ...query } })
    .then(res => res.data.data)
    .catch(err => { alert(err.response?.data.message); return null })
}
export async function getOneArtist(id, query) {
  return await AxiosPublic.get("artist/show/" + id, { params: { ...query } })
    .then(res => res.data.data)
    .catch(err => { alert(err.response?.data.message); return null })
}
